import { useEffect } from 'react';

/**
 * useUnsavedChanges — show the browser's native "Leave site?" dialog when the
 * user attempts to close/reload/navigate while there are unsaved changes.
 *
 * @param {boolean} dirty — true when there are unsaved local changes.
 * @param {string}  [message]  — fallback message (most modern browsers ignore
 *                               and show their default prompt, but we set it
 *                               anyway for older clients).
 */
export function useUnsavedChanges(dirty, message = 'You have unsaved changes. Are you sure you want to leave?') {
  useEffect(() => {
    if (!dirty) return;
    const handler = (e) => {
      e.preventDefault();
      // Chromium needs returnValue set to a non-empty string
      e.returnValue = message;
      return message;
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [dirty, message]);
}

export default useUnsavedChanges;
